import React from 'react';
import Navbar from '../components/Navbar';
import UserProfile from '../Ecomponents/Header/Profile';

const Profile = () => {
  return (
    <div>
        <Navbar/>
        <UserProfile/>
    </div>
  )
}

export default Profile